module.exports = __webpack_public_path__ + "img/time_plan.7b472d6f.svg";